import {getTestProps, type DataTestAttrs} from '@benchling/js-test-utils';
import {Menu} from '@mantine/core';
import React from 'react';

import {ReviewSummary} from 'constants/SourceConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {ReviewSummaryStateKey, TasksReviewSummaryCountKey} from './MyWorkConstants';
import {TasksReviewSummary} from './MyWorkUtils';

export type StatusMenuCountKey = ReviewSummaryStateKey | TasksReviewSummaryCountKey;

function getStatusMenuCount(
  statusCounts: ReviewSummary | TasksReviewSummary | null,
  summaryKey: StatusMenuCountKey,
  isTask: boolean
): string {
  if (statusCounts == null) {
    return '';
  }
  const count = isTask
    ? (statusCounts as TasksReviewSummary)[summaryKey as TasksReviewSummaryCountKey]
    : (statusCounts as ReviewSummary)[summaryKey as ReviewSummaryStateKey];
  return ` (${count})`;
}

interface MyWorkStatusMenuItemProps {
  isSelected: boolean;
  setIsSelected: (selected: boolean) => void;
  statusLabel: string;
  statusCounts: ReviewSummary | TasksReviewSummary | null;
  summaryKey: StatusMenuCountKey;
  isTask: boolean;
  dataTestAttrs: DataTestAttrs;
}

export function MyWorkStatusMenuItem({
  isSelected,
  setIsSelected,
  statusLabel,
  statusCounts,
  summaryKey,
  isTask,
  dataTestAttrs,
}: MyWorkStatusMenuItemProps): JSX.Element {
  const statusMenuCount = getStatusMenuCount(statusCounts, summaryKey, isTask);

  return (
    <Menu.Item
      key={statusLabel}
      aria-label={`${statusLabel}${statusMenuCount}${isSelected ? ' (selected)' : ''}`}
      icon={<BenchlingIcon icon={isSelected ? 'check-circle' : 'circle-outline'} aria-hidden={true} />}
      onClick={() => {
        setIsSelected(!isSelected);
      }}
      {...getTestProps(dataTestAttrs)}
    >
      {statusLabel}
      {statusMenuCount}
    </Menu.Item>
  );
}
